import React from 'react';
import './Security.css';

export default function MicrosoftButton({ onClick, disabled, children = 'Sign in with Microsoft', type = 'button' }) {
  return (
    <button type={type} className="sec-btn sec-btn--microsoft" onClick={onClick} disabled={disabled}>
      <span className="sec-ms-logo" aria-hidden="true">
        <span /><span /><span /><span />
      </span>
      {children}
    </button>
  );
}
